import { collection, addDoc, query, where, getDocs, setDoc, doc, updateDoc, deleteDoc } from 'firebase/firestore'
import { fs, fbStorage, auth } from './index'


// function convertToSlug(Text) {
//     return Text.toLowerCase()
//         .replace(/ /g, '-')
//         .replace(/[^\w-]+/g, '');
// }

export async function addContact(data) {
    
    data.timestamp = Date.now();
    const docRef = await addDoc(collection(fs, "duck-form"), data)
    // console.log("Document written: ", docRef);
    // console.log("Document id: ", docRef.id);
    alert("Form submitted!!!")

    // let title = convertToSlug(data.title)

    await updateDoc(docRef, {
        _id: data.Twitter + " - " + (Date.now()).toString()
    });
}
